import { useEffect, useState } from "react";
import { INSTAGRAM_URL } from "../constants/site";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 border-b border-[#332A24] transition-colors duration-300 ${
        scrolled ? "bg-[#130F0D]/90 backdrop-blur-md" : "bg-[#130F0D]"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-12">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif-display text-xl tracking-wide text-[#E6D5C3]"
        >
          Haus of Lash
        </a>
        <nav className="hidden items-center gap-10 text-xs uppercase tracking-[0.2em] text-[#A89B8F] md:flex">
          <a data-testid="nav-services-link" href="#services" className="transition-colors duration-200 hover:text-[#E6D5C3]">
            Services
          </a>
          <a data-testid="nav-signature-link" href="#signature" className="transition-colors duration-200 hover:text-[#E6D5C3]">
            The Signature
          </a>
          <a
            data-testid="nav-instagram-link"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors duration-200 hover:text-[#E6D5C3]"
          >
            Instagram
          </a>
        </nav>
        <a
          data-testid="nav-enquire-button"
          href="#enquire"
          className="border border-[#332A24] px-5 py-2.5 text-xs uppercase tracking-[0.2em] text-[#E6D5C3] transition-colors duration-200 hover:border-[#C8A88B] hover:text-[#DEBFA2]"
        >
          Inquire
        </a>
      </div>
    </header>
  );
};
